import React, { useEffect, useState } from 'react';
import Chip from '../../../Components/Chip';
import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded';
import AccessAlarmRoundedIcon from '@mui/icons-material/AccessAlarmRounded';
import { useIntl } from 'react-intl';

const getElapsedLabel = (timeSeconds, intl) => {
  if (timeSeconds === undefined || timeSeconds === null) {
    return '';
  }

  // Handle scheduled (future) times - when timeSeconds is negative
  if (timeSeconds < 0) {
    const absoluteSeconds = Math.abs(timeSeconds);
    const days = Math.floor((absoluteSeconds % (3600 * 24 * 30)) / (3600 * 24));
    const hours = Math.floor((absoluteSeconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((absoluteSeconds % 3600) / 60);

    const parts = [
      days ? `${days}d` : '',
      hours ? `${hours}h` : '',
      minutes ? `${minutes}min` : '',
    ].filter(Boolean);

    return `${intl.messages.IN} ${parts.join(' ')}`;
  }

  const days = Math.floor((timeSeconds % (3600 * 24 * 30)) / (3600 * 24));
  const hours = Math.floor((timeSeconds % (3600 * 24)) / 3600);
  const minutes = Math.floor((timeSeconds % 3600) / 60);

  const parts = [
    days ? `${days}d` : '',
    hours ? `${hours}h` : '',
    minutes ? `${minutes}min` : '',
  ].filter(Boolean);

  return `${intl.messages.WAITING_SINCE} ${parts.join(' ')}`;
};

const colorByTimeDifference = (timeDifferenceSeconds) => {
  if (timeDifferenceSeconds < 0) return '#fbb525';
  if (timeDifferenceSeconds < 1800) {
    return '#1f7804';
  }

  return '#cb1d1d';
};

const TimerChip = function TimerChip({ id, dateTime }) {
  const intl = useIntl();
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setNow(Date.now());
    }, 10000);

    return () => clearInterval(intervalId);
  }, []);

  const timeDifferenceSeconds =
    now / 1000 - new Date(dateTime).getTime() / 1000;

  const Icon =
    timeDifferenceSeconds < 0
      ? AccessAlarmRoundedIcon
      : FiberManualRecordRoundedIcon;
  return (
    <Chip
      id={`${id}-timer-chip`}
      variant="contained"
      labelColor="#111"
      labelGrow
      label={`${getElapsedLabel(timeDifferenceSeconds, intl)}`}
      icon={
        <Icon
          sx={{
            color: `${colorByTimeDifference(timeDifferenceSeconds)}!important`,
            fontSize: '30px',
          }}
        />
      }
      color={colorByTimeDifference(timeDifferenceSeconds)}
      height="42px"
      fontSize="1rem"
    />
  );
};

export default TimerChip;
